var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('mq-layout',{attrs:{"mq":['xs', 'sm', 'md']}},[_c('FiltersCompact')],1),_c('mq-layout',{attrs:{"mq":"lg+"}},[_c('FiltersWide')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }